import Swiper from "swiper";
import { Pagination } from "swiper/modules";

const selectors = {
  swiper: "[data-small-posts]",
};

const initSmallPostsSlider = (smallPosts) =>
  new Swiper(smallPosts, {
    modules: [Pagination],

    slidesPerView: "auto",
    spaceBetween: 2,

    pagination: {
      el: "[data-swiper-pagination]",
      clickable: true,
      bulletActiveClass: "active",
      bulletClass: "bullet",
    },

    breakpoints: {
      1024: {
        slidesPerView: 4,
      },
    },
  });

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const smallPosts = document.querySelectorAll(selectors.swiper);

    smallPosts?.forEach(initSmallPostsSlider);
  },
  {
    once: true,
  }
);
